import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _round from 'lodash/round';
import classnames from 'classnames';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';

import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import TypographyStyles from '../../styles/typography';

import ShipmentContent from './Content/Content';
import ShipmentProductItem from './Content/ProductItem';
import ShipmentUnitItem from './Content/UnitItem';

import { titleize } from '../../utils/String';

import { UNIT_ABBREVIATIONS, CURRENCY_SYMBOL } from '../../constants/constants';
import { AppContext } from '../../AppProvider';

export class Contents extends Component {
  static propTypes = {
    shipment: PropTypes.shape({
      handlingUnits: PropTypes.array
    })
  };

  render() {
    const { classes, t, shipment } = this.props;
    const {
      referenceData: { freightClasses }
    } = this.context.globalProps;

    return (
      <Fragment>
        <div
          className={classnames(
            classes.titleRootWrapper,
            classes.shipmentContentTitle
          )}
        >
          <h2 className={classes.headline7}>{t('Shipment Contents')}</h2>
        </div>
        {shipment.handlingUnits.map((handlingUnit, unitNumber) => (
          <ShipmentContent
            key={handlingUnit.id}
            unit={handlingUnit}
            name={`${t('Unit')} ${unitNumber + 1} `}
            shipmentItems={handlingUnit.shipmentItems}
            packageTypeId={handlingUnit.packageTypeId}
            products={handlingUnit.shipmentItems.map((shipmentItem, index) => (
              <ShipmentProductItem
                key={shipmentItem.id}
                productTitle={`${t('Product')} ${index + 1}`}
                name={shipmentItem.product.name}
                sku={shipmentItem.product.sku}
                klass={shipmentItem.product.freightInfo.freightClassId}
                description={shipmentItem.product.description}
                nmfc={
                  shipmentItem.product.freightInfo.nmfcItemCode &&
                  `${shipmentItem.product.freightInfo.nmfcItemCode}-${
                    shipmentItem.product.freightInfo.nmfcSubCode
                  }`
                }
                weight={
                  shipmentItem.product.weightInfo.weight &&
                  `${shipmentItem.product.weightInfo.weight} ${
                    UNIT_ABBREVIATIONS[
                      shipmentItem.product.weightInfo.weightUnit
                    ]
                  }`
                }
                value={
                  shipmentItem.product.valueInfo.value
                    ? `${
                        CURRENCY_SYMBOL[shipmentItem.product.valueInfo.currency]
                      }${shipmentItem.product.valueInfo.value}`
                    : 0
                }
                quantity={shipmentItem.quantity}
                isHazMat={shipmentItem.product.isHazMat}
                hazMat={shipmentItem.product.hazMat}
              />
            ))}
            units={[
              <ShipmentUnitItem
                key={'1'}
                name={t('Unit Description')}
                length={`${handlingUnit.dimensionInfo.length} ${
                  UNIT_ABBREVIATIONS[handlingUnit.dimensionInfo.dimensionUnit]
                }`}
                width={`${handlingUnit.dimensionInfo.width} ${
                  UNIT_ABBREVIATIONS[handlingUnit.dimensionInfo.dimensionUnit]
                }`}
                height={`${handlingUnit.dimensionInfo.height} ${
                  UNIT_ABBREVIATIONS[handlingUnit.dimensionInfo.dimensionUnit]
                }`}
                weight={`${handlingUnit.actualWeightInfo.weight} ${
                  UNIT_ABBREVIATIONS[handlingUnit.actualWeightInfo.weightUnit]
                }`}
                quantity={`${handlingUnit.unitCount} ${titleize(
                  handlingUnit.packageTypeId
                )}`}
                volume={`${_round(handlingUnit.volume, 2)} ${
                  UNIT_ABBREVIATIONS[handlingUnit.volumeUnit]
                }`}
                density={`${_round(handlingUnit.density, 2)} ${
                  UNIT_ABBREVIATIONS[handlingUnit.densityUnit]
                }`}
                klass={
                  (freightClasses.find(
                    freightClass =>
                      freightClass.value ===
                      handlingUnit.freightInfo.freightClassId
                  ) || { title: ''}).title
                    
                }
                value={
                  handlingUnit.value
                    ? `${CURRENCY_SYMBOL[handlingUnit.currency]}${
                        handlingUnit.value
                      }`
                    : 0
                }
              />
            ]}
          />
        ))}
      </Fragment>
    );
  }
}

Contents.contextType = AppContext;
const ContentsWithTranslations = withNamespaces()(Contents);
export default withStyles(
  combineStyles(TypographyStyles, LayoutStyles, SpacingStyles)
)(ContentsWithTranslations);
